export default __webpack_public_path__ + "static/media/light-arrow_left_disabled.6ca865f1.svg";